export default __webpack_public_path__ + "static/media/GhostCh9.90b46b3a.svg";